<script>
import DepartmentColorInput from './DepartmentColorInput';

export default {
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const { values } = this;

    return {
      name: values.name || '',
      color: values.color || '',
    };
  },
  methods: {
    handleNameInput (value) {
      if (this.readonly) {
        return;
      }

      this.name = value;
      this.emitChange();
    },
    handleColorInput (value) {
      if (this.readonly) {
        return;
      }

      this.color = value;
      this.emitChange();
    },

    emitChange () {
      const { name, color } = this;

      this.$emit('change', { name, color });
    },
  },
  render () {
    const { disabled, readonly } = this;

    return (
      <div>
        <div class="form-field">
          <div class="form-field__label">
            <label for="departmentNameInput">
              Название
            </label>
          </div>
          <u-input
            id="departmentNameInput"
            name="name"
            required
            fullwidth
            disabled={disabled}
            static={readonly}
            value={this.name}
            onInput={this.handleNameInput}
          />
        </div>
        <div class="form-field">
          <div class="form-field__label">
            Цвет
          </div>
          <DepartmentColorInput
            static={readonly}
            value={this.color}
            onChange={this.handleColorInput}
          />
        </div>
      </div>
    );
  },
};
</script>
